import { ILoginRequest } from "../../../model/request/auth/ILoginRequest";
import { ILoginRespone } from "../../../model/respone/auth/ILoginRespone";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eAuthActionTypeDefine = {
    LOGIN_START: {} as ILoginRequest,
    LOGIN_SUCCESS: {} as ILoginRespone,
    LOGIN_ERROR: "" as string,
    LOGOUT: undefined as undefined,
    RESTORE_SESSION: {} as ILoginRespone,
};

export const eAuthActionTypeIds = generateActionTypeIds(eAuthActionTypeDefine, "AUTH");

export type IAuthActions = IGenericActionType<typeof eAuthActionTypeDefine, "AUTH">;
